import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import PlanCards from "@/components/feature/PlanCards";
import { dedicatedPlans } from "@/mocks/servidores";

export default function ServerPlans() {
  return (
    <section id="planos-servidores" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          badge="Planos de servidores"
          badgeIcon="ri-server-line"
          title="Servidores dedicados com recursos exclusivos."
          description="Escolha entre configurações em HD ou SSD (RAID10), com memória de 32 GB a 128 GB, no Brasil e no exterior. Todos os planos incluem vCore de CPU 100% garantido."
        />

        <div className="mt-12">
          <PlanCards
            plans={dedicatedPlans}
            columns={3}
            ctaMessage="Ola! Quero fazer o pedido do plano"
            ctaLabel="Fazer pedido no WhatsApp"
            note="Valores de referência. As taxas de ativação, quando aplicáveis, estão indicadas em cada plano e podem ser parceladas."
          />
        </div>

        <Reveal>
          <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-3">
            <div className="rounded-xl border border-background-200 bg-background-50 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-cpu-line text-lg" aria-hidden="true"></i>
              </span>
              <p className="mt-3 font-heading text-base font-semibold text-foreground-950">
                vCore 100% garantido
              </p>
              <p className="mt-1 text-sm text-foreground-600">
                Processamento reservado, sem disputa com outros projetos.
              </p>
            </div>
            <div className="rounded-xl border border-background-200 bg-background-50 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className="ri-flashlight-line text-lg" aria-hidden="true"></i>
              </span>
              <p className="mt-3 font-heading text-base font-semibold text-foreground-950">
                HD ou SSD (RAID10)
              </p>
              <p className="mt-1 text-sm text-foreground-600">
                Escolha a configuração de disco ideal para o seu projeto.
              </p>
            </div>
            <div className="rounded-xl border border-background-200 bg-background-50 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className="ri-map-pin-2-line text-lg" aria-hidden="true"></i>
              </span>
              <p className="mt-3 font-heading text-base font-semibold text-foreground-950">
                Brasil e exterior
              </p>
              <p className="mt-1 text-sm text-foreground-600">
                Opções no Brasil e nos EUA para atender diferentes públicos.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}